import { call, take, put } from 'redux-saga/effects';
import { get, post, putMethod } from '../../utils/api';
import settings from '../../utils/settings';
import {
  DIGITAL_ASSETS_REQUEST,
  DIGITAL_ASSETS_SUCCESS,
  DIGITAL_ASSETS_FAILURE,
  HEADER_LINKS_REQUEST,
  HEADER_LINKS_SUCCESS,
  HEADER_LINKS_FAILURE,
  ECXLUSIVE_UPDATES_REQUEST,
  ECXLUSIVE_UPDATES_SUCCESS,
  ECXLUSIVE_UPDATES_FAILURE,
  PRODUCT_INFO_REQUEST,
  PRODUCT_INFO_SUCCESS,
  PRODUCT_INFO_FAILURE,
  PRODUCT_INFO_UPDATE_REQUEST,
  PRODUCT_INFO_UPDATE_SUCCESS,
  PRODUCT_INFO_UPDATE_FAILURE,
  ALL_DETAILS_REQUEST,
  ALL_DETAILS_SUCCESS,
  ALL_DETAILS_FAILURE,
  GET_NPS_FEEDBACK_REQUEST,
  GET_NPS_FEEDBACK_SUCCESS,
  GET_NPS_FEEDBACK_FAILURE,
  GET_NPS_RATING_REQUEST,
  GET_NPS_RATING_SUCCESS,
  GET_NPS_RATING_FAILURE,
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  PRODUCT_SIGNUP_REQUEST,
  PRODUCT_SIGNUP_SUCCESS,
  PRODUCT_SIGNUP_FAILURE,
  GET_SE_URL_REQUEST,
  GET_SE_URL_SUCCESS,
  GET_SE_URL_FAILURE,
  UPDATE_SE_URL_REQUEST,
  UPDATE_SE_URL_SUCCESS,
  UPDATE_SE_URL_FAILURE
} from './constants';

export function* getAllDetails() {
  while (true) {
    yield take(ALL_DETAILS_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`installer/`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        yield put({
          type: ALL_DETAILS_SUCCESS,
          digitalAssets: result.digital_assets,
          headerBarLinks: result.header_bar_links,
          exclusiveUpdates: result.exclusive_updates,
          productInfo: result.product_information,
          storeCredits: result.store_credits,
          shareData: result.share_data,
          userCertification: result.user_certification
        });
      } else {
        yield put({ type: ALL_DETAILS_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getAllDetails:', error);
      yield put({ type: ALL_DETAILS_FAILURE, error: error });
    }
  }
}

export function* getDigitalAssets() {
  while (true) {
    yield take(DIGITAL_ASSETS_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`installer/digitalAssets`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: DIGITAL_ASSETS_SUCCESS, digitalAssets: result });
      } else {
        yield put({ type: DIGITAL_ASSETS_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getDigitalAssets:', error);
      yield put({ type: DIGITAL_ASSETS_FAILURE, error: error });
    }
  }
}

export function* getHeaderbarLinks() {
  while (true) {
    yield take(HEADER_LINKS_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`installer/headerBarLinks`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: HEADER_LINKS_SUCCESS, headerBarLinks: result });
      } else {
        yield put({ type: HEADER_LINKS_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getHeaderbarLinks:', error);
      yield put({ type: HEADER_LINKS_FAILURE, error: error });
    }
  }
}

export function* getExclusiveUpdatesLinks() {
  while (true) {
    yield take(ECXLUSIVE_UPDATES_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`installer/exclusiveUpdates`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: ECXLUSIVE_UPDATES_SUCCESS, exclusiveUpdates: result });
      } else {
        yield put({ type: ECXLUSIVE_UPDATES_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getExclusiveUpdatesLinks:', error);
      yield put({ type: ECXLUSIVE_UPDATES_FAILURE, error: error });
    }
  }
}

export function* getProductInformation() {
  while (true) {
    yield take(PRODUCT_INFO_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`installer/products`),
        withBearer: true
      });
      if (response.success) {
        const { result } = response;
        yield put({ type: PRODUCT_INFO_SUCCESS, productInfo: result });
      } else {
        yield put({ type: PRODUCT_INFO_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getProductInformation:', error);
      yield put({ type: PRODUCT_INFO_FAILURE, error: error });
    }
  }
}

export function* updateProductInformation() {
  while (true) {
    const request = yield take(PRODUCT_INFO_UPDATE_REQUEST);
    try {
      let response;
      const { productIds = [], successCbk = () => {} } = request.payload;
      response = yield call(post, {
        url: settings.einCoreUrl(`installer/products`),
        body: productIds,
        withBearer: true
      });
      if (response.success) {
        yield put({ type: PRODUCT_INFO_UPDATE_SUCCESS });
        successCbk();
      } else {
        yield put({ type: PRODUCT_INFO_UPDATE_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: updateProductInformation:', error);
      yield put({ type: PRODUCT_INFO_UPDATE_FAILURE, error: error });
    }
  }
}

export function* getNpsFeedbacks() {
  while (true) {
    const request = yield take(GET_NPS_FEEDBACK_REQUEST);
    try {
      let response;
      const { month = -1, year = '', type = '', sortOrder = 'desc', rating = '', comment = '' } = request.payload;
      const sortParam = `sortColumn=createdAt&sortOrder=${sortOrder}`;
      const monthParam = month >= 0 && year ? `&month=${month}&year=${year}` : '';
      const typeParam = type ? `&type=${type}` : '';
      const ratingParam = rating ? `&rating=${rating}` : '';
      const commentParam = comment ? `&comment=${comment}` : '';
      response = yield call(get, {
        url: settings.einCoreUrl(`nps/feedbacks?${sortParam}${monthParam}${typeParam}${ratingParam}${commentParam}`),
        withBearer: true
      });
      if (response.success) {
        yield put({
          type: GET_NPS_FEEDBACK_SUCCESS,
          feedbacks: response.result,
          allFeedbacks: !monthParam && !typeParam ? response.result : ''
        });
      } else {
        yield put({ type: GET_NPS_FEEDBACK_FAILURE, error: response.result.message || response.result.messages });
      }
      window.scroll(0, window.pageYOffset - 1);
    } catch (error) {
      console.log('Saga: getNpsFeedbacks:', error);
      yield put({ type: GET_NPS_FEEDBACK_FAILURE, error: error });
    }
  }
}

export function* getNpsRatings() {
  while (true) {
    yield take(GET_NPS_RATING_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`nps/ratings`),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: GET_NPS_RATING_SUCCESS, ratings: response.result });
      } else {
        yield put({ type: GET_NPS_RATING_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getNpsRatings:', error);
      yield put({ type: GET_NPS_RATING_FAILURE, error: error });
    }
  }
}

export function* getDashboardStats() {
  while (true) {
    yield take(GET_DASHBOARD_STATS_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.einCoreUrl(`installer/getDashboardStats`),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: GET_DASHBOARD_STATS_SUCCESS, dashboardStats: response.result });
      } else {
        yield put({ type: GET_DASHBOARD_STATS_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getDashboardStats:', error);
      yield put({ type: GET_DASHBOARD_STATS_FAILURE, error: error });
    }
  }
}

export function* productSignup() {
  while (true) {
    const request = yield take(PRODUCT_SIGNUP_REQUEST);
    try {
      let response;
      const { successCbk = () => {} } = request.payload;
      response = yield call(post, {
        url: settings.einCoreUrl('installer/productsBetaSignUp'),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: PRODUCT_SIGNUP_SUCCESS });
        successCbk();
      } else {
        yield put({ type: PRODUCT_SIGNUP_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: productSignup:', error);
      yield put({ type: PRODUCT_SIGNUP_FAILURE, error: error });
    }
  }
}

export function* getSEUrl() {
  while (true) {
    yield take(GET_SE_URL_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.digiCoreUrl('installer_se_url'),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: GET_SE_URL_SUCCESS, seUrl: response.result.se_url, installerSEUrlMapping: response.result.installer_se_url_mapping });
      } else {
        yield put({ type: GET_SE_URL_FAILURE, error: response.result.reason });
      }
    } catch (error) {
      console.log('Saga: getSEUrl:', error);
      yield put({ type: GET_SE_URL_FAILURE, error: error });
    }
  }
}

export function* updateSEUrl() {
  while (true) {
    const request = yield take(UPDATE_SE_URL_REQUEST);
    try {
      let response;
      const { data, mappingId, successCbk = () => {}, failureCbk = () => {} }  = request.payload;
      response = yield call(putMethod, {
        url: settings.digiCoreUrl(`installer_se_url/${mappingId}`),
        body: data,
        withBearer: true
      });
      if (response.success) {
        yield put({ type: UPDATE_SE_URL_SUCCESS, seUrl: response.result.se_url, installerSEUrlMapping: response.result.installer_se_url_mapping });
        successCbk();
      } else {
        yield put({ type: UPDATE_SE_URL_FAILURE, error: response.result.reason });
        failureCbk(response.result.reason, response.statusCode);
      }
    } catch (error) {
      console.log('Saga: updateSEUrl:', error);
      yield put({ type: UPDATE_SE_URL_FAILURE, error: error });
    }
  }
}


